import sampleRegistrationCsv from "Static/files/cortex_bulk_registration_sample.csv";
import React from "react";

function BulkDeviceRegistrationSample() {
  return (
    <a
      className="btn btn-default btn-bulk-download"
      download="Cortex Bulk Registration Sample.csv"
      href={sampleRegistrationCsv}
      title="Download Bulk Registration .csv Template."
    >
      <i className="fa fa-download" />
      Download Bulk Registration .csv Template
    </a>
  );
}

export { BulkDeviceRegistrationSample };
